import React from "react";
import { useState } from "react";
import DataTable from "react-data-table-component";
import { ArrowRight, Calendar, MapPin } from "react-feather";
import { Card, Col, Input, Row } from "reactstrap";
import Parser from "html-react-parser";
import Notiflix, { Confirm } from "notiflix";
import moment from "moment";
import PostApiCall from "../Api/Api";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { genareteColor } from "../Helper/GenerateStatusColor";

const ListViewCard = ({
  job,
  type,
  setShowModal,
  setAuditData,
  setModalOpen,
  setIsEditable,
}) => {
  const applyHandler = async (dd) => {
    setAuditData(dd);
    setShowModal(true);
    setIsEditable(dd.fld_auditstatus === "Pending" ? false : true);
  };

  const viewHandler = (data) => {
    setModalOpen(true);
    setAuditData(data);
  };

  return (
    <div className="job-featured">
      <div className="content p-1  px-8 pt-9 pb-7 rounded-4 mb-9 feature-cardOne-adjustments">
        {/* <span className="mb-2 full-time">{job?.OutletStatus}</span> */}
        {/* <div className="part-time">Urgent</div> */}

        <div className="d-flex justify-content-between flex-wrap">
          <div className="">
            <p className="text-success">
              <span> {job?.fld_outletid}</span>
            </p>
            <p
              className="text-truncate text-dark"
              style={{ maxWidth: "200px", fontSize: "18px" }}
            >
              {job.fld_outletname || job.fld_clientname}
            </p>
            <p className="list-unstyled ml-0 card-tag-list">
              <span>
                {job?.fld_address ? job.fld_address.substring(0, 35) : ""}
                {job?.fld_address && job.fld_address.length > 35 ? "..." : ""}
              </span>
            </p>
          </div>
          {/* <div>
            <p className="LightBlueWhite px-2 rounded-3 py-1 ">
              <MapPin size={18} className=" text-center " />
            </p>
          </div> */}
        </div>

        {job?.fld_startdate && type !== "accept" && (
          <div className="d-flex align-items-center my-2">
            <span>
              <Calendar className="text-danger" size={18} />
            </span>
            <div className="d-flex flex-column ml-3">
              <span className="text-dark">
                {moment(job?.fld_applieddate?.split("T")[0]).format("ll")}
              </span>
              <span className="font-size-4">Last date to apply</span>
            </div>
          </div>
        )}

        {/* <p
                  style={{
                    maxHeight: "30px", // Set your desired height
                    overflow: "hidden",
                  }}
                  className="mb-7 font-size-4 text-gray text-clip"
                >
                  {job?.fld_description}
                </p> */}

        {type === "Seeker" && (
          <div className="d-flex justify-content-end btn-det-right">
            <p
              className="btn-primary px-3 rounded"
              style={{ cursor: "pointer" }}
              onClick={() => viewHandler(job)}
            >
              View
            </p>
          </div>
        )}
        {type === "accept" && (
          <div className="text-right baseTextColor">Applied</div>
        )}
        {type === "job" && (
          <div className="text-right">
            <span
              style={{ cursor: "pointer" }}
              // className={`${job.fld_auditstatus==="Pending"?"btnsborderGreen":"btnsborder"}`}
              className={`${
                // job.fld_auditstatus === "Approved" ||
                // job.fld_auditstatus === "Pending"
                //   ? "btnsborderGreen"
                //   : "btnsborder"
                genareteColor(
                  job.fld_auditstatus === null
                    ? "View & Apply"
                    : job.fld_auditstatus
                )
              } px-2 py-1`}
              onClick={() => applyHandler(job)}
            >
              {job.fld_auditstatus === null
                ? "View & Apply"
                : job.fld_auditstatus}

              {/* {job.fld_auditstatus === "Pending" ? "Applied" : job.fld_auditstatus==='Approved' ? job.fld_auditstatus:"View & Apply"} */}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListViewCard;
